import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  TEMPLATE_GENERATE_TEMPLATE_BEGIN,
  TEMPLATE_GENERATE_TEMPLATE_SUCCESS,
  TEMPLATE_GENERATE_TEMPLATE_FAILURE,
  TEMPLATE_GENERATE_TEMPLATE_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function generateTemplate(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: TEMPLATE_GENERATE_TEMPLATE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const { projectId, version } = args;
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_AI_ENGINE}v${version}/generate-template`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_GENERATE_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: TEMPLATE_GENERATE_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGenerateTemplateError() {
  return {
    type: TEMPLATE_GENERATE_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_GENERATE_TEMPLATE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        generateTemplatePending: true,
        generateTemplateError: null,
      };

    case TEMPLATE_GENERATE_TEMPLATE_SUCCESS:
      // The request is success
      return {
        ...state,
        generateTemplatePending: false,
        generateTemplateError: null,
      };

    case TEMPLATE_GENERATE_TEMPLATE_FAILURE:
      // The request is failed
      return {
        ...state,
        generateTemplatePending: false,
        generateTemplateError: action.data.error,
      };

    case TEMPLATE_GENERATE_TEMPLATE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        generateTemplateError: null,
      };

    default:
      return state;
  }
}
